module.exports = __webpack_public_path__ + "img/nopublic.ea5ef294.jpg";